import React from "react";
import { mapReleaseOSToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetReleaseOSColumns from "./ColumnDefinition/ReleaseOSColumn/GetReleaseOSColumns";

const ReleaseOSTable = ({ data, handleOpenPopup, status }) => {
  const columns = GetReleaseOSColumns({
    handleOpenPopup,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default ReleaseOSTable;
